export const openCapture = () => window.dispatchEvent(new CustomEvent('gb:capture'));
export const openPalette = () => window.dispatchEvent(new CustomEvent('gb:palette'));

export type Theme = 'system' | 'light' | 'dark';
export function getTheme(): Theme {
  try {
    const t = localStorage.getItem('gb.theme');
    return t === 'light' || t === 'dark' ? t : 'system';
  } catch {
    return 'system';
  }
}
export function setTheme(t: Theme) {
  try {
    if (t === 'system') localStorage.removeItem('gb.theme');
    else localStorage.setItem('gb.theme', t);
  } catch {
    /* storage unavailable */
  }
  if (t === 'system') delete document.documentElement.dataset.theme;
  else document.documentElement.dataset.theme = t;
}

export type NewNodeType = 'area' | 'goal' | 'list';
export const openNewNode = (type: NewNodeType, parentId?: number | null) =>
  window.dispatchEvent(new CustomEvent('gb:new-node', { detail: { type, parentId: parentId ?? null } }));
export const openMove = (id: number) => window.dispatchEvent(new CustomEvent('gb:move', { detail: { id } }));

let current: { id: number; type: string } | null = null;
export const setDragged = (v: { id: number; type: string } | null) => {
  current = v;
};
export const getDragged = () => current;
